import { Spinner } from '@7shifts/sous-chef-base';
import { useTranslation } from '@src/i18n';
import appIcon from '../assets/7punches-app-icon.svg';
import './LoadingPage.css';

export function LoadingPage() {
    const { t } = useTranslation();
    return (
        <main className="loading-page">
            <div className="loading-page__container">
                <img
                    src={appIcon}
                    alt="7punches"
                    className="loading-page__icon"
                />
                <div role="status" aria-label={t('loading.ariaLabel')}>
                    <Spinner size={24} />
                </div>
            </div>
        </main>
    );
}
